<template>
  <div id="menu">
  <div class="navbar">
      <ul class="menuList">
        <label v-for="(item,index) in menuList" :key="item.name">
        <router-link :to="{path:'/m'+item.link}" v-if="index!=1">
          <li :class="linkName ==item.link?'active':''">
          <span>{{$t(item.name)}}</span>
          </li>
        </router-link>
        <li :class="linkName ==item.link?'active':''" @mouseover="menuShows()" v-if="index==1">
        <span>{{$t(item.name)}}<img src="/static/images/common/ic_more.png" alt=""></span>
        </li>
        </label>
        <li class="item languageBtn" @click="changeLang">
          <span>
            <span :class="lang_en?'langSelect':''">EN</span><span>/</span><span :class="!lang_en?'langSelect':''">中文</span></span>
        </li>
      </ul>
    </div>

    <div class="mask" @click='maskBtn'>

    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: 'app-menu',
  data() {
    return {
      menuShow:false,
      menuList:[
        {
          name:"menu.Home",
          link:'Home'
        },
        {
          name:"menu.Features",
          link:'Features'
        },
        {
          name:"menu.Products",
          link:'Products'
        },
        {
          name:"menu.FAQ",
          link:'FAQ'
        },
        {
          name:"menu.Blog",
          link:'Blog'
        },
        {
          name:"menu.Contact",
          link:'Contact'
        },
        {
          name:"menu.About",
          link:'About'
        },
      ],
      linkName:'',
      lang_en:false
    };
  },
  //定义这个sweiper对象
  computed: {

  },
  mounted() {
    this.url_change()
    if(this.$getCookie('langs')=='en'){
                this.lang_en =true
            }else{
                this.lang_en =false
            }
  },
  methods: {
    menuBtn(){

      document.querySelector('body').setAttribute('class', 'open-nav')
    },
    maskBtn(){
        document.querySelector('body').removeAttribute('class')
    },
    changeLang() {
      let that = this
      if(this.$getCookie('langs')=='en'){
          this.$setCookie('langs',"zh");
          this.lang = 'zh';
          this.$i18n.locale = this.lang;//关键语句
          // that.$router.push('/Home')
          // window.location.reload()
          this.lang_en =false
      }else{
          this.$setCookie('langs',"en");
          this.lang = 'en';
          this.$i18n.locale = this.lang;//关键语句
          // that.$router.push('/Home')
          // window.location.reload()
          this.lang_en =true
      }
      document.querySelector('body').removeAttribute('class')
    },
    menuShows(){
      this.menuShow = true
    },
    menuHiddens(){
      this.menuShow = false
    },
     url_change () {
        let that = this, url = window.location.href.split('/')[3].split('?')
        let link =''
        if(url[0]=='Software'||url[0]=='Hardware'){
          link = 'Features'
        }else{
          link = url[0]
        }
        that.linkName = link
      }
  },
  watch: {      // 监听路由变化
    $route (to, from) {
      this.url_change()
      this.menuShow = false
      document.querySelector('body').removeAttribute('class')
    }
  }
};
</script>
<style scoped lang="less" type="text/less">
#menu{
    position: fixed;
    top: 0;
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-in;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .navbar{

    .menuList{
      background: #fff;
      position: fixed;
      width: 300px;
      right:-300px;
      top: 0;
      color: #333;
      padding: 15px 0;
      line-height: 55px;
      a{
        color: #333;
      }
      li{
        padding-left: 40px;
        text-align: left;
      }
    }
  }
  .navMenu{
    position:fixed;
    width: 100%;
    left: 0;
    z-index: 8;
    background: #fff;
    padding: 36px 0;
    box-shadow:0px 3px 10px rgba(0,0,0,0.08);
    .con{
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .left,.right{
        display: flex;
        justify-content: center;
        align-items: center;
        .menuImg{
          margin-right: 30px;
        }
        .title{
          color: #333;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          left: -16px;
        }
        .titleSub{
          padding-top: 10px;
          ul li{
            color: #999;
            font-size: 12px;
            line-height: 24px;
            list-style: disc;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/common/menu.vue